import { HttpClient } from '@angular/common/http';
import {
  DefaultTranspiler,
  provideTransloco,
  Translation,
  TRANSLOCO_TRANSPILER,
  TranslocoLoader,
  TranslocoModule,
} from '@jsverse/transloco';
import { Injectable, isDevMode, NgModule, inject } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);


  getTranslation(lang: string) {
    return this.http.get<Translation>(`${environment.assetPath}/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['de', 'en'],
        defaultLang: 'de',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    // Add this line to satisfy the InjectionToken error
    { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
  ],
})
export class TranslocoRootModule {}
